import React from "react";
import Context from "../../../Context";
import ReportHandler from "../../../report";
import EssenceFiles from "../../Essence/EssenceFiles";
import Blocker from "../../Misc/Blocker";

export default class ReportRecentItem extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      report: {},
      html: "",
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.recentItemId !== this.props.recentItemId) {
      this.load();
    }
  }

  pendingStart = () => {
    this.setState({pending: true});
    if (this.props.onPendingStart) {
      this.props.onPendingStart();
    }
  };

  pendingEnd = () => {
    this.setState({pending: false});
    if (this.props.onPendingEnd) {
      this.props.onPendingEnd();
    }
  };

  load = async () => {
    this.pendingStart();
    let initResult = {};
    let buildResult = {};
    let reportHandler = {};
    if (this.props.reportId) {
      reportHandler = new ReportHandler(this.props.reportId);
      initResult = await reportHandler.init();
    }
    this.setState({initResult, reportHandler, buildResult});
    this.pendingEnd();
  };

  render() {
    const {pending, report, html} = this.state;
    return (
      <>
        <Blocker hAuto spinnerFixed on={pending}>
          {this.props.recentItemId && (
            <>
              {report.id && (
                <>
                  <EssenceFiles
                    listOnly
                    essence="report"
                    id={report.id}
                    key={report.id}
                  />
                </>
              )}
              {html && (
                <>
                  <hr/>
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: html || "",
                    }}
                  ></div>
                </>
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
